<template>
		<gc-modal condition="true" @cancel="$emit('cancel')" modal-class="gc-modal--wide report-modal">
			<template slot="messageTitle">
				{{title}}
			</template>

			<template slot="body">
				<div class="report-modal__inner">
					<div v-for="(reason, index) in availableReasons" :key="index" class="report-modal__radio">
						<label class="report-modal__label--radio">
							<input type="radio" :value="reason" v-model="selectedReason" :disabled="formDisabled">
							{{reason}}
						</label>
					</div>

					<label class="report-modal__label">
						Add a comment <span class="report-modal__label--asterisk">*</span>
						<textarea v-model="message" placeholder="Provide more details" spellcheck="true" :disabled="formDisabled" :maxlength="messageMaxLength"></textarea>
					</label>
					<div class="report-modal__after">
					<label class="report-modal__label--help">
						Before reporting, please read our <a :href="guidelinesUrl"
							target="_blank"
							class="report-modal__label--link">
						Community Guidelines
					</a>
					</label>
					</div>
				</div>

			</template>

			<template slot="footer">
				<a class="gc-modal__cancel" @click="$emit('cancel')">Cancel</a>
				<button class="btn btnRed" @click="confirm" :disabled="formDisabled || !message.length">Report</button>
			</template>
		</gc-modal>
</template>
<script>
	import axios from 'axios'
	import GcModal from './GcModal'

	export default {
		name: 'ReportModal',
		components: {
			GcModal
		},
		props: ['modalParams'],
		data () {
			const availableReasons = this.modalParams.reasons || ['Spam', 'Violates Community Guidelines'];

			return {
				formDisabled: false,
				availableReasons,
				selectedReason: availableReasons[0],
				message: '',
				messageMaxLength: Grabcad.AttributeLimits.Generic.CONTENT_DESCRIPTION_LONG,
				title: this.modalParams.title,
				guidelinesUrl: Grabcad.site.help_center_guidelines
			};
		},
		methods: {
			confirm () {
				this.formDisabled = true;

				const payload = {
					reason: this.selectedReason,
					message: this.message,
				};
				payload[this.modalParams.reportable] = this.modalParams.reportableId;

				axios.post('/report', payload)
						.then(this.onReported)
						.catch(this.handleRequestError)
						.finally(this.$emit('cancel'));
			},
			onReported () {
				this.$eventHub.$emit('addAlert', {
					type: 'success',
					message: 'Thank You! Your report has been sent to our support team.'
				});
			},
			handleRequestError () {
				this.$eventHub.$emit('addAlert', {
					type: 'error',
					message: 'Could not submit report. Please try again.'
				});
			},
		}
	}
</script>
